const getFlagCode = (code) => {
  if (code === 'BQ') return 'NL' // Caribbean Netherlands
  if (code === 'BV') return 'NO' // Bouvet Island
  if (code === 'IO') return 'GB' // British Indian Ocean Territory
  if (code === 'GF') return 'FR' // French Guiana
  if (code === 'GP') return 'FR' // Guadeloupe
  if (code === 'HM') return 'AU' // Heard & McDonald Islands
  if (code === 'BL') return 'FR' // Saint Barthélemy
  if (code === 'SX') return 'NL' // Sint Maarten
  if (code === 'PM') return 'FR' // Saint Pierre and Miquelon
  if (code === 'SJ') return 'NO' // Svalbard and Jan Mayen
  if (code === 'UM') return 'US' // US Minor Outlying Islands

  if (code === 'XK') return 'RS' // Kosovo politically sensitive to use serbia flag, but who cares
  return code
}

export default getFlagCode
